// src/routes/RecordingForcedSpirometryRouter.jsx
import React, { Suspense, lazy } from "react";
import { ClipLoader } from "react-spinners"; // ✨ spinner
// import RequireFreemiumOrPlan from "../components/guards/RequireFreemiumOrPlan";

const RecordingForcedSpirometry = lazy(() =>
  import("recordingForcedSpirometry/App")
);

export default function RecordingForcedSpirometryRouter(props) {
  return (
    // <RequireFreemiumOrPlan>
    <Suspense
      fallback={
        <div className="flex h-full w-full items-center justify-center">
          <ClipLoader size={48} />
        </div>
      }
    >
      <RecordingForcedSpirometry {...props} />
    </Suspense>
    // </RequireFreemiumOrPlan>
  );
}
